import type { MouseEvent } from "react";

import { Steps as AntdSteps, StepsProps as AntdStepsProps } from "antd";
import { cx } from "class-variance-authority";

import { TabSpec } from "../../componentTypes/tab";

import * as theme from "./Steps.css";

export interface StepSpec extends TabSpec {
    status?: AntdStepsProps["status"];
}

export interface StepsProps {
    stepSpecs: StepSpec[];
    currentStepId: string;
    limitedWidth?: boolean;
}

export function Steps({
    currentStepId,
    stepSpecs,
    limitedWidth = false,
}: StepsProps) {
    const items = stepSpecs.map((stepSpec) => ({
        key: stepSpec.id,
        title: stepSpec.label,
        status: stepSpec.status,
        onClick: (event: MouseEvent<HTMLElement>) =>
            stepSpec.onClick({
                key: stepSpec.id,
                keyPath: [],
                item: stepSpec,
                domEvent: event,
            }),
    }));
    return (
        <AntdSteps
            className={cx(theme.steps, limitedWidth && theme.limitedWidth)}
            current={stepSpecs.findIndex(({ id }) => id === currentStepId)}
            size="small"
            items={items}
        />
    );
}
